// extracted by mini-css-extract-plugin
export default {"banner":"TrialPromoinfo__banner--33gkE"};